import type { EntitlementWithDetails } from '@/@types/entitlement';
import { EntitlementType } from '@/@types/entitlement';

type FreeExtensionEntitlementDetails = {
  extraOneFreePeriod?: boolean;
};

export const hasExtraOneFreePeriod = (entitlementDetails?: string): boolean => {
  if (!entitlementDetails) {
    return false;
  }

  try {
    const parsedEntitlementDetails = JSON.parse(entitlementDetails) as FreeExtensionEntitlementDetails;
    return parsedEntitlementDetails.extraOneFreePeriod === true;
  } catch {
    return false;
  }
};

export const hasEligibleFreeExtensionEntitlement = (entitlements?: EntitlementWithDetails[]): boolean =>
  entitlements?.some(
    (entitlement) =>
      entitlement.serviceType === EntitlementType.DOCUMENTS_PLUS_RENT &&
      hasExtraOneFreePeriod(entitlement.entitlementDetails),
  ) ?? false;
